import React from 'react';
import StyledTypography from 'views/rebranded-module/location-module/LocationsViewV2/components/ERClubBadge/ERClubBadge.styles';

const ERClubBadge = (props) => {
  const { content, className } = props;
  return (
    <StyledTypography component="span" className={className}>
      {content.clubEaglerider}
    </StyledTypography>
  );
};

export { ERClubBadge };
